export default "__VITE_ASSET__BkrRWmGQ__"